<template lang="pug">
.row
  input#widget_layout_type.form-control.hidden(type='hidden', name='widget[layout_type]', :value="layout_type_name")
  .col-12
    .widget_layout_type
      label.form-control-label レイアウト種別（クリックで選択）
  .col-3
    .card(:class="{ 'bg-active': layout_type_name=='tile_plus_list' }", @click="select('tile_plus_list')")
      .card-header
        h3.card-title
          i.fas.fa-check-circle(v-if="layout_type_name=='tile_plus_list'")
          i.far.fa-check-circle(v-else)
          | {{tile_plus_list}}
      .card-body.text-center
        img(src="/img/layout_types/tile_plus_list_h.png", v-if="layout_type_name=='tile_plus_list'")
        img(src="/img/layout_types/tile_plus_list.png", v-else)
  .col-3
    .card(:class="{ 'bg-active': layout_type_name=='all_list' }", @click="select('all_list')")
      .card-header
        h3.card-title
          i.fas.fa-check-circle(v-if="layout_type_name=='all_list'")
          i.far.fa-check-circle(v-else)
          | {{all_list}}
      .card-body
        img(src="/img/layout_types/all_list_h.png", v-if="layout_type_name=='all_list'")
        img(src="/img/layout_types/all_list.png", v-else)
  .col-3
    .card(:class="{ 'bg-active': layout_type_name=='single_rectangle' }", @click="select('single_rectangle')")
      .card-header
        h3.card-title
          i.fas.fa-check-circle(v-if="layout_type_name=='single_rectangle'")
          i.far.fa-check-circle(v-else)
          | {{single_rectangle}}
      .card-body
        img(src="/img/layout_types/single_rectangle_h.png", v-if="layout_type_name=='single_rectangle'")
        img(src="/img/layout_types/single_rectangle.png", v-else)
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    tile_plus_list: String,
    all_list: String,
    single_rectangle: String,
    layout_type: String,
  },
  data(){
    return {
      layout_type_name: ""
    }
  },
  methods: {
    select(name){
      this.layout_type_name = name
    },
  },
  async mounted(){
    await Vue.nextTick()
    this.layout_type_name = this.layout_type
  },
  watch: {
  },
}
</script>
<style lang="scss" scoped>
.card-body{
  img{width:100%;}
}
.card-header{
  i{
    margin-right:0.5em;
  }
  h3{font-size:0.9em;}
}
.card-header{
  h3{
    color:#999;
  }
}
.bg-active{
  background: linear-gradient(134deg, #dc3545, #ff5438);
  .card-header{
    h3{
      color:white;
    }
  }
}

</style>
